export default "__VITE_ASSET__BSStzMC9__"